// extracted by mini-css-extract-plugin
export default {"custom-scrollbar":"mainStyle_custom-scrollbar__wkPXb","custom-scrollbar-menu":"mainStyle_custom-scrollbar-menu__73S1q"};